import { en } from './en'
import { fr } from './fr'

export const opportunityRequestsPage = {
  en,
  fr
}